import { Box, BoxVerticalAlignment, Loader as WixLoader } from '@wix/design-system';
import { Property } from 'csstype';
import React, { FC, memo } from 'react';

type LoaderProps = {
  dataHook?: string;
  position?: Property.Position;
  height?: string;
  width?: string;
  margin?: string;
  backgroundColor?: string;
  verticalAlign?: BoxVerticalAlignment;
};

export const Loader: FC<LoaderProps> = memo(function LoaderComponent({ dataHook, ...rest }) {
  return (
    <Box align="center" {...rest}>
      <WixLoader dataHook={dataHook} />
    </Box>
  );
});
